var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduatedStartups1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80078 7.2002C1.80078 8.4078 9.08619 11.7002 10.7883 11.7002C12.4903 11.7002 19.7758 8.4078 19.7758 7.2002C19.7758 5.99259 12.4903 2.7002 10.7883 2.7002C9.08619 2.7002 1.80078 5.99259 1.80078 7.2002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39453 9.8999L5.61513 14.9668C5.61954 15.0682 5.63051 15.1699 5.65991 15.2671C5.75079 15.5675 5.91828 15.8404 6.17381 16.0239C8.17312 17.4586 13.4009 17.4586 15.4002 16.0239C15.6558 15.8404 15.8232 15.5675 15.9141 15.2671C15.9435 15.1699 15.9545 15.0682 15.959 14.9668L16.1795 9.8999",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.426 8.5498V14.8498M18.426 14.8498C17.7132 16.1515 17.3981 16.8489 17.0779 17.9998C17.0084 18.4093 17.0636 18.6157 17.3459 18.7989C17.4605 18.8733 17.5983 18.8998 17.7349 18.8998H19.1033C19.2488 18.8998 19.3956 18.8695 19.5154 18.7869C19.7777 18.606 19.8452 18.4075 19.7741 17.9998C19.4935 16.9311 19.136 16.2005 18.426 14.8498Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduatedStartups1);
export default __webpack_public_path__ + "static/media/Graduated Startups (1).37f22e9919e18df7f5145e612a6aceb8.svg";
export { ForwardRef as ReactComponent };